import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const createPaymentIntent = (payload) =>
  fetch(buildUrl("/api/payments/intents"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const createEventPaymentIntent = (payload) =>
  fetch(buildUrl("/api/payments/event-intents"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const getPaymentIntent = (paymentIntentId, options = {}) =>
  fetch(buildUrl(`/api/payments/intents/${paymentIntentId}`), {
    credentials: "include",
    ...options,
  }).then(handleResponse);

const paymentsApi = { createPaymentIntent, createEventPaymentIntent, getPaymentIntent };

export default paymentsApi;
